// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iJ8u","largestCol":"styles_largestCol__qev4D","smallestCol":"styles_smallestCol__2XOLt"};